import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { StyledCommentGrid } from "./TabsContent.styles";
import { CardShareTabs, CommunityClusterSelect } from "../../components";
import type { SharedPost } from "../../queries/community.types";

export function TabsContentCommunity({
  loId,
  sharedPosts
} : {
  loId:string,
  sharedPosts?: SharedPost
}
) {
  const { t } = useTranslation();
  return (

    <StyledCommentGrid>
      <CommunityClusterSelect predicate={ (cluster) => cluster.is_share_enabled } sx={ {
        width: "900px",
        maxWidth: "100%"
      } }></CommunityClusterSelect>
      {
        sharedPosts?.data.map((sharedPost) =>{
          const ownerUserId = sharedPost.owner_id;
          const ownerUser = sharedPosts.enrichedInformation?.users?.find(user => user.owner_id === ownerUserId);
          return (
            <CardShareTabs
              postId={ sharedPost.id }
              topicOwner={ ownerUserId }
              key={ `comment--${sharedPost.id}` }
              body={ sharedPost.body }
              created={ sharedPost.created }
              loId={ loId }
              ownerName={ `${ownerUser?.name} ${ownerUser?.surname}` || "" }
              ownerImage={ ownerUser?.profileImageUrl }
            />
          );}
        )
      }
      { !(sharedPosts?.data) || sharedPosts.data.length === 0?<Grid
        alignItems={ "center" }
        display={ "flex" }
        flexDirection={ "column" }
        justifyContent={ "center" }
        gap={ 2 }

      >
        <Typography
          padding={ "42px 80px" }
          textAlign={ "center" }
        >
          { t("no_shared_posts_available") }
        </Typography>
      </Grid>:<></> }
    </StyledCommentGrid>

  );
}
